import { useNavigate } from "react-router-dom";
import ErrorImage from "../../../assets/img/Error400.png";
import Explore from "../../../assets/icons/ErrorExploreIcon.svg";

const Error400 = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-white p-3">
      <div className="text-center">
        <h5
          className="fw-bold mb-4"
          style={{
            fontSize: "clamp(24px, 5vw, 44px)",
            fontWeight: 700,
          }}
        >
         Something's not quite right.
        </h5>
        <p
          className="mb-2"
          style={{
            fontSize: "clamp(16px, 3vw, 24px)",
            lineHeight: 1.5,
          }}
        >
          This request can't be processed right now. Don't worry, you can
          <br />
        find your way back.
        </p>
        <div>
          <img
            src={ErrorImage}
            alt="404 Illustration"
            className="img-fluid mb-2"
            style={{
              maxWidth: "100%",
              width: "clamp(200px, 50vw, 500px)", 
              height: "auto",
            }}
          />
        </div>
        <button
          className="btn btn-primary py-2 px-3 mt-2"
          style={{
            fontSize: "clamp(14px, 2.5vw, 18px)", 
            padding: "10px 20px",
          }}
          onClick={() => navigate("/")}
          aria-label="Navigate back to homepage" 
        >
          Explore{" "}
          <span className="ms-2">
            <img
              src={Explore}
              alt="Explore icon"
              style={{
                width: "clamp(12px, 2vw, 15px)",
                height: "auto",
                verticalAlign: "middle",
              }}
            />
          </span>
        </button>
      </div>
    </div>
  );
};

export default Error400;

